/***************************************************************************************************
 * BROWSER POLYFILLS
 */

// Evergreen browsers: Angular only requires ES2015+
// If you need legacy browser support (IE etc.) you'd add polyfills here.
// For most modern Angular 13 apps you don't need anything here by default.

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
